import React, { useRef, useCallback, useEffect, useState } from 'react';
import { Omega, ChevronDown } from 'lucide-react';

const SymbolsMenu = ({ title, symbols, onInsertSymbol, tourTarget }) => {
  const scrollRef = useRef(null);
  const [scrolledBottom, setScrolledBottom] = useState(false);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    // Check if scrolled to bottom (within 4px tolerance)
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 4;
    setScrolledBottom(atBottom);
  }, []);

  // Reset scroll state when dropdown opens (on hover)
  const handleMouseEnter = useCallback(() => {
    setScrolledBottom(false);
    // Check after a tick to allow display:block to take effect
    requestAnimationFrame(() => {
      const el = scrollRef.current;
      if (!el) return;
      // If content doesn't overflow, hide the fade
      if (el.scrollHeight <= el.clientHeight) {
        setScrolledBottom(true);
      }
    });
  }, []);

  const hasDescriptions = symbols.some((item) => item.description);

  return (
    <div className="dropdown" onMouseEnter={handleMouseEnter} data-tour={tourTarget}>
      <button className="toolbar-button">
        <Omega size={16} /> <span className="toolbar-label">{title}</span> <ChevronDown size={14} />
      </button>
      <div className={`dropdown-scroll-wrapper ${scrolledBottom ? 'scrolled-bottom' : ''}`}>
        <div className="dropdown-content" ref={scrollRef} onScroll={handleScroll}>
          {symbols.map((item, index) => (
            <div
              key={index}
              className="dropdown-item"
              onClick={() => onInsertSymbol(item.symbol)}
              title={item.description || item.symbol}
            >
              {hasDescriptions && item.description ? (
                <div className="dropdown-item-with-desc">
                  <span className="dropdown-item-symbol">{item.symbol}</span>
                  <span className="dropdown-item-desc">{item.description}</span>
                </div>
              ) : (
                <span className="dropdown-item-symbol">{item.symbol}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SymbolsMenu;
